import { Component, OnInit, Input } from '@angular/core';
import { Telefono } from '../../security/user/telefono.model';

@Component({
  selector: 'app-usuario-phone-list',
  templateUrl: './usuario-phone-list.component.html',
  styleUrls: ['./usuario-phone-list.component.scss']
})
export class UsuarioPhoneListComponent implements OnInit {

  @Input() telefono: Telefono;
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-phone-list/usuario-phone-list.component.ts